module.exports = __webpack_public_path__ + "static/media/illustration_exceed-model-limit.ff000220.svg";